import React from 'react'
import { browserHistory, Router } from 'react-router'
import './Icon.scss'
import E404 from './Error/404'

import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import { MuiThemeProvider } from '@material-ui/core'
import Style from './Style'

import Utils from 'EurestoFonction/Utils'

import { connectWS } from '../../Utilitaire/Websocket/index'
import { withStyles } from '@material-ui/core/styles'
import { SnackbarProvider } from 'notistack'

const mainDivStyle = { height: '100%' }

const styles = theme => ({
  success: {
    backgroundColor: 'white',
    color: '#03BD5B',
    border: '1px solid #03BD5B',
  },
  error: {
    backgroundColor: 'white',
    color: '#DC3545',
    border: '1px solid #DC3545',
  },
})

class App extends React.Component {

  eventListener = (event) => {
    if ((
      localStorage.getItem('token') === ''
      || localStorage.getItem('token') === undefined
      || localStorage.getItem('token') === null
      || localStorage.getItem('token') === 'null') && User.User.get().id) {
      console.log('###########I focus the window ! Event in Edge...')
      User.Disconnect.get()
    } else {
      //console.log('I focus the window ! Event in Edge...')
      localStorage.setItem('token', sessionStorage.getItem('token'))
      //connectWS()
    }

    window.addEventListener('focus', this.eventListener, true, { once: true })
  }

  constructor(props) {
    super(props)
    Data.init()

    sessionStorage.setItem('app_identifier', Utils.uuidv4())

    const location = browserHistory.getCurrentLocation()
    if (sessionStorage.getItem('token') === undefined || sessionStorage.getItem('token') === null || sessionStorage.getItem('token') === 'null') {
      sessionStorage.setItem('token', '')
    }

    if (location.query.token) {
      localStorage.setItem('token', location.query.token)
      sessionStorage.setItem('token', location.query.token)
    } else if (sessionStorage.getItem('token') !== '' && sessionStorage.getItem('token') !== undefined && sessionStorage.getItem('token') !== null && sessionStorage.getItem('token') !== 'null') {
    } else if (localStorage.getItem('token') !== '' && localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'null') {
      sessionStorage.setItem('token', localStorage.getItem('token'))
    }

    window.addEventListener('focus', this.eventListener, true, { once: true })
    User.ColorWebSite.init(this.changeColor)

    this.state = {
      style: Style(),
      hasError: false
    }
  }

  changeColor = () => {
    this.setState({
      style: Style()
    })
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
  }

  render() {
    if (this.state.hasError) {
      return <E404 />
    }
    return (
      <MuiThemeProvider theme={this.state.style}>
        <SnackbarProvider maxSnack={3}
          classes={{
            variantSuccess: this.props.classes.success,
            variantError: this.props.classes.error
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}>
          <div style={mainDivStyle}>
            <Router history={browserHistory} children={this.props.routes} />
          </div>
        </SnackbarProvider>
      </MuiThemeProvider>
    )
  }
}

export default withStyles(styles)(App)



// WEBPACK FOOTER //
// ./app/App/Static/App.js